import {useMarkConversion} from "./use-mark-conversion.ts";
import {usePublishAnalyticsEvent} from "./use-publish-analytics-event.ts";
import type {WithMarkConversionProps} from "./with-mark-conversion.tsx";

interface Props {
    children: (props: WithMarkConversionProps) => JSX.Element;
}

// Provides markConversion and publishAnalyticsEvent functions to its children.
// This is useful when hooks or HOCs aren't an option.
export const MarkConversionProvider = (props: Props) => {
    const markConversion = useMarkConversion();
    const publishAnalyticsEvent = usePublishAnalyticsEvent();

    return props.children({markConversion, publishAnalyticsEvent});
};
